import { type Ref, computed, ref, watch } from 'vue';
import { useRoute } from 'vue-router';

import { useRoutes } from '@/shared/routes';

interface IUseSaveSort {
  sort?: Ref<string>;
}

const SKIP_NAME_PAGE = useRoutes.EPK_ITEM_NAME;
const STORY_SORT_CONSENT_KEY = 'story_sort_consent';

export const useSaveSort = ({ sort }: IUseSaveSort) => {
  const route = useRoute();

  const currSort = ref(sort?.value);
  const sortId = computed(() => currSort?.value?.slice(1));
  const sortValue = computed(() => currSort?.value?.[0]);
  const sortDirection = computed(() => currSort?.value?.[0] === '*');

  const isSkipPage = computed(() => route.name === SKIP_NAME_PAGE);

  const setItem = computed(() =>
    JSON.stringify({ path: route.path, sort: currSort?.value })
  );

  const loadSort = () => localStorage.getItem(STORY_SORT_CONSENT_KEY);

  const saveSort = () =>
    localStorage.setItem(STORY_SORT_CONSENT_KEY, setItem.value);

  const removeSort = () => localStorage.removeItem(STORY_SORT_CONSENT_KEY);

  const checkSort = () => {
    const stored = loadSort();

    if (!stored) removeSort();
    else {
      const { path, sort } = JSON.parse(stored);

      if (isSkipPage.value) return;
      else if (path !== route.path) removeSort();
      else currSort.value = sort;
    }
  };

  const ckeckSkipSaveSort = (fn: () => void) => (!isSkipPage.value ? fn() : '');

  checkSort();

  watch(
    () => [sort?.value, currSort.value],
    () => ckeckSkipSaveSort(saveSort)
  );

  return {
    currSort,
    sortId,
    sortValue,
    sortDirection,
  };
};
